
<template lang="pug">
  Slide(
    :enable-scroll-indication="true"
    :class="this.$parent.showSidebar && 'toc-open'"
  )#slide_1000
    .orange-box-top
      .blue-box-top
    .orange-strip
    .content-wrapper 
      .header 
        h1 Stop, Look, and Think
        p Even though cybercriminals are always coming up with new ways to trick you, you can spot their attacks by slowing down and searching for warning signs.
        p Select each button below to review examples of how employees like you protected their organization by taking the time to stop, look, and think before taking action.
      ModalStack
        Modal(
          title="Business Email Compromise"
          :image="require('@/assets/img/KSAT25-45-1000-1-btn.png')"
          alt=""
          :image-completed="require('@/assets/img/KSAT25-45-1000-1-complete.png')"
          :alt-completed="modalCompleted"
          :completion-by-inner-component="true"
          :video="require('@/assets/videos/SAF-1000-2_Ares_BEC_2025.mp4')"
          :vtt="require('@/assets/videos/SAF-1000-2_Ares_BEC_2025.vtt')"
          size="normal KSAT25"
        )
        Modal(
          title="Sensitive Information"
          :image="require('@/assets/img/KSAT25-45-1000-2-btn.png')"
          alt=""
          :image-completed="require('@/assets/img/KSAT25-45-1000-2-complete.png')"
          :alt-completed="modalCompleted"
          :completion-by-inner-component="true"
          :video="require('@/assets/videos/SERF25-0600-Sensitive_Information.mp4')"
          :vtt="require('@/assets/videos/SERF25-0600-Sensitive_Information.vtt')"
          size="normal KSAT25"
        )
        Modal(
          title="Artificial Intelligence"
          :image="require('@/assets/img/KSAT25-45-1000-3-btn.png')"
          alt=""
          :image-completed="require('@/assets/img/KSAT25-45-1000-3-complete.png')"
          :alt-completed="modalCompleted"
          :completion-by-inner-component="true"
          :video="require('@/assets/videos/SERF25-0800-Artificial_Intelligence.mp4')"
          :vtt="require('@/assets/videos/SERF25-0800-Artificial_Intelligence.vtt')"
          size="normal KSAT25"
        )

</template>
<script>
export default {
  main: '#slide_1000',

  data() {
    return {
      modalCompleted:
        'Complete',
    };
  },
};
</script>

<style lang="scss" scoped>
$spacer: 1em;
$fontSize: 1rem;

.slide-wrapper {
  padding: 0 !important;
  .orange-strip {
    float: left;
    background-color: #fe9800;
    margin-top: 50px;
    height: 10px;
    width: 70%;
  }
  .orange-box-top {
    height: 100px;
    width: 20%;
    float: right;
    background-color: #fe9800;
    position: relative;
  }
  .blue-box-top {
    height: 60%;
    width: 90%;
    position: absolute;
    bottom: 0;
    margin-right: -50%;
    background-color: #013a60;
  }

  ::v-deep .focusable-div {

    .content-wrapper {
      max-width: 80%;
      margin: auto;
      height: 100%;
      padding: 10% 5%;
      h2 {
        font-family: "SegoeUI-Bold", Helvetica, Arial, serif;
        padding-top: 20px;
        font-size: 24px;
      }
      p {
        font-family: "SegoeUI-Bold", Helvetica, Arial, sans-serif;
        font-size: 16px;
        color: #013a60;
      }
      a {
        color: #0057b8;
        font-weight: 500;
      }
      a:hover {
        color: #444;
      }
      img {
        margin-top: 1em;
      }
      .grid-row:last-of-type {
        gap: 10px;
        padding-bottom: 70px;
      }
    }

    .ModalStack {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 70px;
      .h-stack {
        display: none;
      }
      .modal {
        width: 100%;
        margin-bottom: $spacer;
      }
      .h4 {
        font-size: $fontSize;
        font-weight: 700;
      }
    }
    @include mq('tablet-small') {
      .ModalStack {
        margin-top: $spacer * 2;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-evenly;
      }
    }
  }
}
</style>
